/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable operator-linebreak */
/* eslint-disable quotes */
/* eslint-disable no-shadow */
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import useListenSize from '../hooks/useListenSize';
import { segmentEvent } from '../helpers/sendEvent';
import { confirmAonAgreement } from '../redux/actions';
import useApi from '../hooks/useApi';

function CheckoutAon() {
  const { request } = useApi();
  const dispatch = useDispatch();
  const store = useSelector(state => ({
    userId: state.loanInfo?.userId,
    phone: state.contact?.phone,
    retailerId: state.technical?.retailerId,
    retailerName: state.technical?.retailerName,
    dueAtCheckout: state.loanInfo?.checkout?.due_at_checkout,
  }));

  const history = useHistory();
  useListenSize();

  const [isAonViewClosed, setIsAonViewClosed] = useState(false);
  const [ifLearnMoreClicked, setIfLearnMoreClicked] = useState(false);
  const [yesNoClicked, setYesNoClicked] = useState('yes');

  useEffect(() => {
    segmentEvent('page', 'Katapult Boost presented', {
      phone: store.phone,
      retailer_id: store.retailerId,
      retailer_name: store.retailerName,
      due_at_checkout: store.dueAtCheckout,
    });
  }, []);

  const onCloseClick = () => {
    setIsAonViewClosed(true);
    history.push('/checkout');
  };

  const onBackClicked = () => {
    setIfLearnMoreClicked(false);
  };

  const onYesClick = () => {
    setYesNoClicked('yes');
  };

  const onNoClick = () => {
    setYesNoClicked('no');
  };

  const onAonSubmit = async () => {
    if (yesNoClicked === 'yes') {
      const payload = {
        opted_for_aon_subscription: true,
      };
      request.updateAonEnrollmentStatus(store.userId, payload);
      history.push('/lease-agreement');
    } else {
      // Reset any prior Boost confirmation when the user declines
      dispatch(confirmAonAgreement(false));
      request.updateAonEnrollmentStatus(store.userId, { opted_for_aon_subscription: false });
      history.push('/lease-agreement');
    }
  };

  return (
    <>
      <div className="k-content-wrapper">
        <>
          <section className="k-checkout-mobile-sidebar">
            <div>Back to checkout</div>
          </section>
          <section className="k-info k-shopify-checkout-agree">
            <h1 className="k-h1-large">Read and agree to the Terms of your Agreement</h1>
            <div className="k-checkbox animate__animated animate__fadeInDown">
              <label htmlFor="terms_agreement" className="k-checkout-checkbox">
                <input type="checkbox" id="terms_agreement" name="terms_agreement" />
                You have read and agreed to the <span className="k-shopify-checkout-link">Price Tag Disclosures</span>
              </label>
            </div>
            <div className="k-checkbox animate__animated animate__fadeInDown">
              <label htmlFor="lease_agreement" className="k-checkout-checkbox">
                <input type="checkbox" id="lease_agreement" name="lease_agreement" />
                You have read and agreed to the <span className="k-shopify-checkout-link">Lease Agreement</span>
              </label>
            </div>
            <div className="k-checkbox animate__animated animate__fadeInDown">
              <label htmlFor="my_id" className="k-checkout-checkbox">
                <input type="checkbox" id="my_id" name="my_id" />
                My ID matches the printed name on the card used for payment
              </label>
            </div>
          </section>
          <section className="k-info k-shopify-checkout-agree">
            <h1 className="k-h1-large">Read and agree to the Terms of your Agreement</h1>
            <div className="k-checkbox animate__animated animate__fadeInDown">
              <label htmlFor="terms_agreement" className="k-checkout-checkbox">
                <input type="checkbox" id="terms_agreement" name="terms_agreement" />
                You have read and agreed to the <span className="k-shopify-checkout-link">Price Tag Disclosures</span>
              </label>
            </div>
            <div className="k-checkbox animate__animated animate__fadeInDown">
              <label htmlFor="lease_agreement" className="k-checkout-checkbox">
                <input type="checkbox" id="lease_agreement" name="lease_agreement" />
                You have read and agreed to the <span className="k-shopify-checkout-link">Lease Agreement</span>
              </label>
            </div>
            <div className="k-checkbox animate__animated animate__fadeInDown">
              <label htmlFor="my_id" className="k-checkout-checkbox">
                <input type="checkbox" id="my_id" name="my_id" />
                My ID matches the printed name on the card used for payment
              </label>
            </div>
          </section>
        </>
      </div>
      {!isAonViewClosed && (
        <div className="plugin-aon">
          <div className="plugin-aon-half-transparent-overlay" />
          <div className="plugin-aon-main-overlay">
            <div className="plugin-aon-header">
              {ifLearnMoreClicked && (
                <div
                  className="plugin-aon-back"
                  onClick={onBackClicked}
                  onKeyPress={onBackClicked}
                  role="button"
                  tabIndex={0}
                  aria-label="Go back"
                >
                  <svg width="23" height="16" viewBox="0 0 23 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="
                    M0.292892 8.70711C-0.0976315 8.31658 -0.0976315 7.68342 0.292892 7.29289L6.65685 0.928932C7.04738 0.538408 7.68054 0.538408 8.07107 0.928932C8.46159 1.31946 8.46159 1.95262 8.07107 2.34315L2.41421 8L8.07107 13.6569C8.46159 14.0474 8.46159 14.6805 8.07107 15.0711C7.68054 15.4616 7.04738 15.4616 6.65685 15.0711L0.292892 8.70711ZM1 8V7H23V8V9H1V8Z"
                      fill="black"
                    />
                  </svg>
                </div>
              )}
              <div className="plugin-aon-header-image" />
              <div
                className="plugin-aon-close"
                onClick={onCloseClick}
                onKeyPress={onCloseClick}
                role="button"
                tabIndex={0}
                aria-label="Close"
              />
            </div>
            {!ifLearnMoreClicked && (
              <div className="plugin-aon-content">
                <div className="plugin-aon-content-protect">Protect your lease and save with Katapult Boost</div>
                <div className="plugin-aon-content-sub-header">
                  You&apos;ll have access to the below and MORE for just $12.99/month!
                </div>
                <div className="plugin-aon-list">
                  <ul className="plugin-aon-list-ul">
                    <li>
                      <svg width="12" height="11" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="
                      M8.00378 0.445204L3.80248 6.06595L1.9908 3.694C1.80952 3.45846 1.54314 3.30542 1.25029 3.26852C0.957432 3.23163 0.66208 3.31391 0.429207 3.49727C0.196333 3.68063 0.0450134 3.95004 0.00853663 4.24624C-0.0279401 4.54244 0.0534138 4.84117 0.234701 5.0767L2.93554 8.57281C3.04021 8.70678 3.17368 8.81488 3.32582 8.8889C3.47796 8.96291 3.64477 9.0009 3.81359 8.99998C3.98333 8.99957 4.15072 8.95984 4.30293 8.88385C4.45513 8.80785 4.5881 8.6976 4.69164 8.56156L9.771 1.81667C9.95082 1.57815 10.0296 1.27716 9.98998 0.979906C9.95038 0.682651 9.79564 0.413482 9.55982 0.231615C9.324 0.0497478 9.02641 -0.0299211 8.73251 0.0101345C8.43861 0.0501901 8.17248 0.20669 7.99267 0.445204H8.00378Z"
                          fill="#ED5370"
                        />
                      </svg>
                      <span className="plugin-aon-list-right">
                        Accident Assist*<sup>†</sup> merchandise protection
                      </span>
                    </li>
                    <li>
                      <svg width="12" height="11" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="
                      M8.00378 0.445204L3.80248 6.06595L1.9908 3.694C1.80952 3.45846 1.54314 3.30542 1.25029 3.26852C0.957432 3.23163 0.66208 3.31391 0.429207 3.49727C0.196333 3.68063 0.0450134 3.95004 0.00853663 4.24624C-0.0279401 4.54244 0.0534138 4.84117 0.234701 5.0767L2.93554 8.57281C3.04021 8.70678 3.17368 8.81488 3.32582 8.8889C3.47796 8.96291 3.64477 9.0009 3.81359 8.99998C3.98333 8.99957 4.15072 8.95984 4.30293 8.88385C4.45513 8.80785 4.5881 8.6976 4.69164 8.56156L9.771 1.81667C9.95082 1.57815 10.0296 1.27716 9.98998 0.979906C9.95038 0.682651 9.79564 0.413482 9.55982 0.231615C9.324 0.0497478 9.02641 -0.0299211 8.73251 0.0101345C8.43861 0.0501901 8.17248 0.20669 7.99267 0.445204H8.00378Z"
                          fill="#ED5370"
                        />
                      </svg>
                      <span className="plugin-aon-list-right">
                        Rental Protection*<sup>†</sup> if merchandise is damaged or stolen
                      </span>
                    </li>
                    <li>
                      <svg width="12" height="11" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="
                      M8.00378 0.445204L3.80248 6.06595L1.9908 3.694C1.80952 3.45846 1.54314 3.30542 1.25029 3.26852C0.957432 3.23163 0.66208 3.31391 0.429207 3.49727C0.196333 3.68063 0.0450134 3.95004 0.00853663 4.24624C-0.0279401 4.54244 0.0534138 4.84117 0.234701 5.0767L2.93554 8.57281C3.04021 8.70678 3.17368 8.81488 3.32582 8.8889C3.47796 8.96291 3.64477 9.0009 3.81359 8.99998C3.98333 8.99957 4.15072 8.95984 4.30293 8.88385C4.45513 8.80785 4.5881 8.6976 4.69164 8.56156L9.771 1.81667C9.95082 1.57815 10.0296 1.27716 9.98998 0.979906C9.95038 0.682651 9.79564 0.413482 9.55982 0.231615C9.324 0.0497478 9.02641 -0.0299211 8.73251 0.0101345C8.43861 0.0501901 8.17248 0.20669 7.99267 0.445204H8.00378Z"
                          fill="#ED5370"
                        />
                      </svg>
                      <span className="plugin-aon-list-right">
                        Payment waivers*<sup>†</sup> if you’re unexpectedly unemployed or sick
                      </span>
                    </li>
                    <li>
                      <svg width="12" height="11" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="
                      M8.00378 0.445204L3.80248 6.06595L1.9908 3.694C1.80952 3.45846 1.54314 3.30542 1.25029 3.26852C0.957432 3.23163 0.66208 3.31391 0.429207 3.49727C0.196333 3.68063 0.0450134 3.95004 0.00853663 4.24624C-0.0279401 4.54244 0.0534138 4.84117 0.234701 5.0767L2.93554 8.57281C3.04021 8.70678 3.17368 8.81488 3.32582 8.8889C3.47796 8.96291 3.64477 9.0009 3.81359 8.99998C3.98333 8.99957 4.15072 8.95984 4.30293 8.88385C4.45513 8.80785 4.5881 8.6976 4.69164 8.56156L9.771 1.81667C9.95082 1.57815 10.0296 1.27716 9.98998 0.979906C9.95038 0.682651 9.79564 0.413482 9.55982 0.231615C9.324 0.0497478 9.02641 -0.0299211 8.73251 0.0101345C8.43861 0.0501901 8.17248 0.20669 7.99267 0.445204H8.00378Z"
                          fill="#ED5370"
                        />
                      </svg>
                      <span className="plugin-aon-list-right">
                        Road Hazard*<sup>†</sup>
                      </span>
                    </li>
                    <li>
                      <svg width="12" height="11" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="
                      M8.00378 0.445204L3.80248 6.06595L1.9908 3.694C1.80952 3.45846 1.54314 3.30542 1.25029 3.26852C0.957432 3.23163 0.66208 3.31391 0.429207 3.49727C0.196333 3.68063 0.0450134 3.95004 0.00853663 4.24624C-0.0279401 4.54244 0.0534138 4.84117 0.234701 5.0767L2.93554 8.57281C3.04021 8.70678 3.17368 8.81488 3.32582 8.8889C3.47796 8.96291 3.64477 9.0009 3.81359 8.99998C3.98333 8.99957 4.15072 8.95984 4.30293 8.88385C4.45513 8.80785 4.5881 8.6976 4.69164 8.56156L9.771 1.81667C9.95082 1.57815 10.0296 1.27716 9.98998 0.979906C9.95038 0.682651 9.79564 0.413482 9.55982 0.231615C9.324 0.0497478 9.02641 -0.0299211 8.73251 0.0101345C8.43861 0.0501901 8.17248 0.20669 7.99267 0.445204H8.00378Z"
                          fill="#ED5370"
                        />
                      </svg>
                      <span className="plugin-aon-list-right">Savings on Local and Online Shopping</span>
                    </li>
                  </ul>
                  <div className="plugin-aon-learn-more">Plus more you won’t want to miss!</div>
                </div>
                <div
                  className={`plugin-aon-yes-no ${yesNoClicked === 'yes' ? 'plugin-aon-yes-no-selected' : ''}`}
                  onClick={onYesClick}
                  onKeyPress={onYesClick}
                  role="button"
                  tabIndex={0}
                >
                  <div className="plugin-aon-radio">
                    <div
                      className={`plugin-aon-radio-outer ${
                        yesNoClicked === 'yes' ? 'plugin-aon-yes-no-outer-selected' : ''
                      }`}
                    >
                      {yesNoClicked === 'yes' && (
                        <div className="plugin-aon-radio-inner plugin-aon-yes-no-inner-selected" />
                      )}
                    </div>
                  </div>
                  <div className="plugin-aon-yes-content">
                    Yes, I want Katapult Boost for <span className="plugin-aon-price">$12.99/month</span>
                  </div>
                </div>
                <div
                  className={`plugin-aon-yes-no ${yesNoClicked === 'no' ? 'plugin-aon-yes-no-selected' : ''}`}
                  onClick={onNoClick}
                  onKeyPress={onNoClick}
                  role="button"
                  tabIndex={0}
                >
                  <div className="plugin-aon-radio">
                    <div
                      className={`plugin-aon-radio-outer ${
                        yesNoClicked === 'no' ? 'plugin-aon-yes-no-outer-selected' : ''
                      }`}
                    >
                      {yesNoClicked === 'no' && (
                        <div className="plugin-aon-radio-inner plugin-aon-yes-no-inner-selected" />
                      )}
                    </div>
                  </div>
                  <div className="plugin-aon-yes-content">No, I don&apos;t want Katapult Boost</div>
                </div>
                <div className="k-submit animate__animated animate__fadeInUp plugin-aon-button">
                  <button type="button" onClick={onAonSubmit} disabled={!yesNoClicked}>
                    {yesNoClicked === 'no' ? 'Continue to Checkout' : 'Continue to review and sign my agreement'}
                  </button>
                </div>
                <div className="plugin-aon-not-available">
                  *These benefits are NOT insurance or a substitute for insurance. Subject to limitations, restrictions
                  and exclusions. Benefits vary by state. Not all members are eligible for all benefits.
                  <br />
                  <br />
                  †Must be a member in good standing at the time of event.
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default CheckoutAon;
